import React from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { saleOffersSelector } from 'src/features'
import { CustomCol, FormLabels, CustomSelect } from 'src/components'

const SaleOfferGroupSelector: React.FC = () => {
  const { t } = useTranslation()
  const { offerGroups: { data: groups } } = useAppSelector(saleOffersSelector)

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('SalesOffer.Group')}
        subtitle={t('SalesOffer.GroupLabel')}
      />
    </CustomCol>
    <CustomCol>
      <CustomSelect
        name='sale_offer_group'
        disabled={groups.length === 0}
        placeholder={t('SalesOffer.GroupPlaceholder')}
        required
      >
        {groups.map(g => <Select.Option key={g.id} value={g.id}>{g.name}</Select.Option>)}
      </CustomSelect>
    </CustomCol>
  </Row>
}

export default SaleOfferGroupSelector
